import { env } from '@cc-shopping/platform-env';
import type { StructuredContentDocumentWithRenderer } from '../../hydration/types';
import { renderStructuredContent } from '../../renderContext';

export type WPBlockProps = StructuredContentDocumentWithRenderer<{
  content: string;
  id: string;
}>;

export const WPBlock = ({ props }: WPBlockProps) => {
  if (!props.content) {
    if (env.NEXT_PUBLIC_DEPLOYABLE_ENV === 'stage' || env.NEXT_PUBLIC_DEPLOYABLE_ENV === 'dev') {
      console.warn(`WPBlock Structured Content Renderer missing content for doc id: ${props.id}`);
    }
    return null;
  }
  return renderStructuredContent(props.content);
};
